export default __webpack_public_path__ + "static/media/logo.e3fa4ff7.png";